module.exports = __webpack_public_path__ + "fonts/HelveticaNowMicro-ExtraBold.fc31d35c.woff2";